import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShareLinkComponent } from './share-link.component';

const routes: Routes = [{ path: '', component: ShareLinkComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShareLinkRoutingModule { }
